<template>
  <FullImageHero
    title="Exploit"
    :tagline="tagline"
    :image="require('@/assets/img/sponsor_bg.png')"
  >
    <template #content>
      <p class="sponsor-description">
        {{ eventDescription }}
      </p>
    </template>
    <template #button>
      <router-link class="sponsor-btn" to="#sponsor-acquire">
        <Button type="text"> become a sponsor </Button>
      </router-link>
    </template>
  </FullImageHero>
</template>

<script>
import Button from "@/components/common/Button";
import FullImageHero from "@/components/common/FullImageHero";
import moment from "moment";

export default {
  name: "SponsorHero",
  props: {
    eventName: {
      type: String,
      default: "",
    },
    eventDescription: {
      type: String,
      default:
        "ExploitCon is a national conference that focuses on providing attendees with technical information from industry experts in order to educate the IT community on advancements in Cyber Security and Information Technology. Enjoy presentations from local speakers on a wide range of IT topics, connect with peers and other industry experts, or get hands on experience at any of our villages. At Exploit we work hard to provide our attendees with the latest and greatest in Cyber Security and our main goal is to make sure you walk away more educated.",
    },
    eventDate: {
      type: String,
      default: "",
    },
  },
  components: {
    Button,
    FullImageHero,
  },
  computed: {
    date() {
      if (!this.eventDate) {
        return "";
      }
      return moment.utc(this.eventDate).format("MMMM DD, YYYY");
    },
    tagline() {
      if (!this.eventName) {
        return "";
      }
      return `Sponsor ${this.eventName} on ${this.date}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables";

.sponsor-btn {
  text-decoration: none;
  button {
    margin-top: 72px;
    display: inline;
  }
}

.sponsor-description {
  font-family: $Lato;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0.05em;
  color: #ffffffcc;
  margin-top: 16px;
}
</style>
